module.exports = __webpack_public_path__ + "static/Davos_logo.32d9a3c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Davos_logo.svg
// module id = 12
// module chunks = 35783957827783 40787343088564 110745335445244 114276838955818